import { Identifiable, Document } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeDocument(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Document>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/api/documents/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeDocument };
